// Port of api/fuel/app/classes/controller/api/monty/groups/edit.php
import Constants from 'offline/constants'
import DB from 'offline/db'
import {
	currentUser,
	groupPayload,
	invalid,
	normaliseAvatar,
	persist,
	resolveGroup,
	slugTaken,
	validGroupData
} from './shared'

export default function(params) {
	var user = currentUser(params)
	var group = resolveGroup(params)
	if (!user || !group) return invalid(Constants.API_ERROR_UNAUTHORISED)
	if (user.get_id() !== group.get_user_id()) return invalid(Constants.API_ERROR_UNAUTHORISED)
	if (group.get_type() !== Constants.GROUP_TYPE_STANDARD) return invalid(Constants.API_ERROR_UNAUTHORISED)

	var data = params.data || {}
	var slug = user.get_upgrade() ? String(data.slug || '').trim().toLowerCase() : group.get_slug()
	var requireSlug = !!user.get_upgrade()

	if (!validGroupData(Object.assign({}, data, { slug: slug }), requireSlug)) return invalid()
	if (slugTaken(slug, group.get_id())) return invalid(Constants.API_ERROR_GROUP_SLUG_TAKEN)

	DB.run('UPDATE groups SET group_name = ?, group_membership = ?, group_avatar = ?, group_slug = ? WHERE group_id = ?', [
		(data.name || '').trim(),
		parseInt(data.membership, 10),
		normaliseAvatar(data.avatar, group.get_avatar()),
		slug,
		group.get_id()
	])

	return persist(groupPayload(group.get_id()))
}
